module.exports = __webpack_public_path__ + "static/media/outsource.a913766b.svg";